module.exports = __webpack_public_path__ + "img/tokuten_ico6.a6f578cb.png";